var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShipmentStatus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190.069,
    height: 69.943,
    viewBox: "0 0 190.069 69.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 190.069,
    height: 69.943,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_Shipment_Status",
    "data-name": "icon_Shipment Status",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 137.87,
    height: 29.181,
    transform: "translate(30.697 31.127)",
    fill: "#006837"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 137.87,
    height: 29.181,
    transform: "translate(30.697 31.127)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 0.141
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 1.271,
    height: 27.986,
    transform: "translate(30.018 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 1.269,
    height: 27.986,
    transform: "translate(36.913 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 1.269,
    height: 27.986,
    transform: "translate(43.806 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 1.269,
    height: 27.986,
    transform: "translate(50.699 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 1.269,
    height: 27.986,
    transform: "translate(57.592 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 1.269,
    height: 27.986,
    transform: "translate(64.485 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 1.269,
    height: 27.986,
    transform: "translate(71.38 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 1.269,
    height: 27.986,
    transform: "translate(78.273 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 1.269,
    height: 27.986,
    transform: "translate(85.167 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 1.269,
    height: 27.986,
    transform: "translate(92.061 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 1.269,
    height: 27.986,
    transform: "translate(98.955 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 1.269,
    height: 27.986,
    transform: "translate(105.848 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 1.269,
    height: 27.986,
    transform: "translate(112.741 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 1.269,
    height: 27.986,
    transform: "translate(119.634 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 1.269,
    height: 27.986,
    transform: "translate(126.527 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 1.269,
    height: 27.986,
    transform: "translate(133.422 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 1.269,
    height: 27.986,
    transform: "translate(140.315 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 1.271,
    height: 27.986,
    transform: "translate(147.209 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 1.269,
    height: 27.986,
    transform: "translate(154.104 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 1.269,
    height: 27.986,
    transform: "translate(160.995 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 1.271,
    height: 27.986,
    transform: "translate(167.888 32.321)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 140.407,
    height: 2.168,
    transform: "translate(29.43 30.154)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 137.87,
    height: 29.181,
    transform: "translate(30.659 0.973)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 137.87,
    height: 29.181,
    transform: "translate(30.659 0.973)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 0.141
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 1.269,
    height: 27.988,
    transform: "translate(29.98 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 1.269,
    height: 27.988,
    transform: "translate(36.873 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 1.271,
    height: 27.988,
    transform: "translate(43.766 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 1.269,
    height: 27.988,
    transform: "translate(50.661 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 1.269,
    height: 27.988,
    transform: "translate(57.554 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 1.269,
    height: 27.988,
    transform: "translate(64.449 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 1.269,
    height: 27.988,
    transform: "translate(71.342 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 1.269,
    height: 27.988,
    transform: "translate(78.235 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 1.269,
    height: 27.988,
    transform: "translate(85.128 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 1.269,
    height: 27.988,
    transform: "translate(92.022 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 1.269,
    height: 27.988,
    transform: "translate(98.915 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 1.269,
    height: 27.988,
    transform: "translate(105.81 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 1.269,
    height: 27.988,
    transform: "translate(112.703 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 1.269,
    height: 27.988,
    transform: "translate(119.596 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 1.269,
    height: 27.988,
    transform: "translate(126.491 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 1.269,
    height: 27.988,
    transform: "translate(133.384 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 1.269,
    height: 27.988,
    transform: "translate(140.276 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 1.269,
    height: 27.988,
    transform: "translate(147.17 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 1.269,
    height: 27.988,
    transform: "translate(154.064 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 1.271,
    height: 27.988,
    transform: "translate(160.957 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 1.269,
    height: 27.988,
    transform: "translate(167.852 2.167)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 140.407,
    height: 2.166,
    transform: "translate(29.392 0.001)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M186.071,41.1v1.11h-1.526v-1.8h-3.8v-.42h-1.777v.42h-.937l0,.41h-.551V31.58h1.515V26.619h-1.515V26.2h-.583v.831H166.172a2.387,2.387,0,1,0-4.111,2.428h-36.81v1.186h.648v1.3h1.347v-1.3h5.712v1.47h1.347v-1.47H138.9v1.47h1.347v-1.47h4.809v1.271H146.4V30.647h4.531v1.47h1.349v-1.47h3.433l-.01,1.453,4.287.028.01-1.482h2.581v-.57a2.377,2.377,0,0,0,1.535.57,2.275,2.275,0,0,0,.337-.035v1.565H124.139v-4.3H121.2v4.3H109.828V30.723H89.494v1.453H57.321V30.354h5.712v1.762h1.347V30.354h1.49V29.222H28.626v1.133H38v1.822h-3.43l.055-1.887H30.335l-.055,1.887H23.658V41.42H19.221v-14.6h-.412v14.6H12.061v-14.6h-.412V41.011h-.541v-.422H9.332v.422H5.526v1.8H4V41.7H0v3.553H4v-.591H5.526v1.427H9.332v.5l.995-.5h.914v2.206a.444.444,0,0,0,.443.443h3.84a5.19,5.19,0,0,0,9.33,1.9l.339.34a1.673,1.673,0,0,0,1.53.571H37.5a1.673,1.673,0,0,0,1.53-.571l.339-.34a5.189,5.189,0,0,0,9.23-1.512H149.036l.556-.148c.023.09.045.178.073.266l.033.616.208-.012a5.188,5.188,0,0,0,8.956.789l.337.34a1.675,1.675,0,0,0,1.53.571h10.778a1.674,1.674,0,0,0,1.528-.571l.339-.34a5.189,5.189,0,0,0,8.963-5.152h2.207V44.061h1.526v.593h4V41.1Zm-27.164,8.106h.048l.023.445-.051-.051ZM55.974,32.176H51.38V30.354h4.594ZM39.346,30.354H50.035v1.822H39.346Zm-11.7,18.821c0,.606-.352.754-.784.327l-1.126-1.11a5.087,5.087,0,0,0,.058-.733,5.166,5.166,0,0,0-.6-2.41H26.55a1.1,1.1,0,0,1,1.1,1.1Zm9.7.327c-.432.427-.784.279-.784-.327V46.352a1.1,1.1,0,0,1,1.1-1.1h.571l.693.169a5.167,5.167,0,0,0-.513,2.241,5.087,5.087,0,0,0,.058.733Zm121.822.342-.2-.193.419-.022-.022-.425h.048l.023.422.419-.022-.02-.4h.033v.345c0,.545-.317.676-.7.294m9.418,0c-.387.382-.7.251-.7-.294V47.336h1.746a4.664,4.664,0,0,0-.081.854,4.747,4.747,0,0,0,.051.656Z",
    transform: "translate(0 17.09)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 2.94,
    height: 4.787,
    transform: "translate(66.205 44.694)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M105.985,31.2l-.068-1.3.447,1.279V28.238l-.483.967-.048-.93-.184.008.153,2.932Z",
    transform: "translate(69.835 18.666)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 0.694,
    height: 11.029,
    transform: "translate(180.786 48.224)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 8.572,
    height: 1.957,
    transform: "translate(70.095 47.384)",
    fill: "#231f20"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShipmentStatus);
export default __webpack_public_path__ + "static/media/icon_Shipment Status.df0b66b289e6d980bdc44dbb87a1e8f6.svg";
export { ForwardRef as ReactComponent };